export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';

export const WIP_SECTIONS = [];